import { data } from '../../svg/Design/data';
import { makeIcon } from '../makeIcon';

export const Design = makeIcon(data, 'design', 'Design');

export default Design;
